const inputTypes = {
    "DIGITS": "DIGITS",
    "DATE": "DATE",
    "CVV": "CVV",
    "PHONE_CAPTURE": "PHONE_CAPTURE",
    "ZIP_CAPTURE": "ZIP_CAPTURE",
    "SSN_CAPTURE": "SSN_CAPTURE",
    "CREDIT_CARD_CAPTURE": "CREDIT_CARD_CAPTURE",
    "CC_EXPIRATION_DATE": "CC_EXPIRATION_DATE",
    "ALPHANUMERIC_CAPTURE": "ALPHANUMERIC_CAPTURE",
    "BANK_ROUTING_NUMBER": "BANK_ROUTING_NUMBER",
    "POSTAL_CODE_CAPTURE": "POSTAL_CODE_CAPTURE",
    "DOB_CAPTURE": "DOB_CAPTURE",
    "FUTURE_DATE_CAPTURE": "FUTURE_DATE_CAPTURE",
    "TIME_OF_DAY_CAPTURE": "TIME_OF_DAY_CAPTURE",
    "YN_GENERIC": "YN_GENERIC",
    "DIGIT_CAPTURE": "DIGIT_CAPTURE",
    "NUMBER_CAPTURE": "NUMBER_CAPTURE",
    "DYNAMIC_MATCHING": "DYNAMIC_MATCHING",
    "EMAIL_CAPTURE": "EMAIL_CAPTURE",
    "ADDRESS_CAPTURE": "ADDRESS_CAPTURE",
    "FIRST_NAME_CAPTURE": "FIRST_NAME_CAPTURE",
    "LAST_NAME_CAPTURE": "LAST_NAME_CAPTURE",
    "CURRENCY_CAPTURE": "CURRENCY_CAPTURE",
    "SIMPLE_CHOICE": "SIMPLE_CHOICE",
    "NONE": "NONE"
};

export default Object.freeze(inputTypes);